module.exports = __webpack_public_path__ + "img/coffee-machine.67e519ee.png";